import React, { useState } from 'react';
import dayjs from 'dayjs';

import Button from '../../../../components/Button/Button';
import SelectClients from '../../../../components/Selects/SelectClients';
import ClientCreateModal from '../../../../components/ClientCreateModal/ClientCreateModal';
import { colors } from '../../../../constants/colors';

// getClients Ð¾ÑÐ´Ð°ÑÑ Ð´Ð¾ÐºÑÐ¼ÐµÐ½Ñ Ð²Ð»Ð¾Ð¶ÐµÐ½Ð½ÑÐ¼ Ð¾Ð±ÑÐµÐºÑÐ¾Ð¼, Ð° Ð°Ð´ÑÐµÑ â Ð¿Ð¾ ÑÐ°ÑÑÑÐ¼.
const documentOf = (client) => {
  const doc = client?.document;
  if (!doc?.document_number) return '';
  const issued = doc.document_date ? ` Ð¾Ñ ${dayjs(doc.document_date).format('DD.MM.YYYY')}` : '';
  return `${doc.document_number}${issued}`;
};

const addressOf = (client) =>
  [
    client?.city?.title,
    client?.registration_street,
    client?.registration_house_number && `Ð´. ${client.registration_house_number}`,
    client?.registration_apartment_number && `ÐºÐ². ${client.registration_apartment_number}`,
  ]
    .filter(Boolean)
    .join(', ');

const Row = ({ label, value }) => (
  <div style={{ display: 'grid', gridTemplateColumns: '220px 1fr', padding: '6px 0' }}>
    <span style={{ color: colors.dimGray }}>{label}</span>
    <span style={{ color: colors.blackPearl }}>{value || 'â'}</span>
  </div>
);

/**
 * ÐÐ»Ð¾Ðº Â«ÐÑÐ¾Ð´Ð°Ð²ÐµÑÂ» Ð´Ð¾Ð³Ð¾Ð²Ð¾ÑÐ° Ð¿Ð¾ÑÑÑÐµÐ½Ð¸Ñ. ÐÑÐ¾Ð´Ð°Ð²ÐµÑ â Ð¾Ð±ÑÑÐ½ÑÐ¹ ÐºÐ»Ð¸ÐµÐ½Ñ CRM, Ð¿Ð¾ÑÑÐ¾Ð¼Ñ
 * Ð¾Ð½ Ð»Ð¸Ð±Ð¾ ÑÐ¾Ð·Ð´Ð°ÑÑÑÑ Ð·Ð´ÐµÑÑ Ð¶Ðµ (eGov / Ð²ÑÑÑÐ½ÑÑ) Ð² Ð¼Ð¾Ð´Ð°Ð»ÐºÐµ, Ð»Ð¸Ð±Ð¾ Ð²ÑÐ±Ð¸ÑÐ°ÐµÑÑÑ Ð¸Ð· Ð±Ð°Ð·Ñ.
 */
const SellerBlock = ({ seller, onChange, error }) => {
  const [modal, setModal] = useState(false);
  const [picking, setPicking] = useState(false);

  const client = seller?.client;

  return (
    <>
      {seller ? (
        <div>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginBottom: 10,
            }}
          >
            <span style={{ fontSize: 18, fontWeight: 600, color: colors.blackPearl }}>
              {client ? `${client.surname || ''} ${client.name || ''} ${client.middlename || ''}`.trim() : seller.label}
            </span>
            <span
              role="button"
              onClick={() => onChange(null)}
              style={{ color: colors.cameo, textDecoration: 'underline', cursor: 'pointer' }}
            >
              ÐÑÐ±ÑÐ°ÑÑ Ð´ÑÑÐ³Ð¾Ð³Ð¾
            </span>
          </div>
          <Row label="ÐÐÐ" value={client?.iin} />
          <Row label="Ð¢ÐµÐ»ÐµÑÐ¾Ð½" value={client?.phone} />
          <Row label="ÐÐ¾ÐºÑÐ¼ÐµÐ½Ñ" value={documentOf(client)} />
          <Row label="ÐÐ´ÑÐµÑ" value={addressOf(client)} />
        </div>
      ) : (
        <>

          {picking ? (
            <div style={{ maxWidth: 520 }}>
              <SelectClients value={seller} onChange={onChange} error={!!error} />
              <span
                role="button"
                onClick={() => setPicking(false)}
                style={{
                  display: 'inline-block',
                  marginTop: 12,
                  color: colors.cameo,
                  textDecoration: 'underline',
                  cursor: 'pointer',
                }}
              >
                ÐÑÐ¼ÐµÐ½Ð°
              </span>
            </div>
          ) : (
            <div style={{ display: 'flex', gap: 12 }}>
              <Button text="ÐÐ¾Ð±Ð°Ð²Ð¸ÑÑ Ð½Ð¾Ð²Ð¾Ð³Ð¾ ÐºÐ»Ð¸ÐµÐ½ÑÐ°" fill onClick={() => setModal(true)} />
              <Button text="ÐÑÐ±ÑÐ°ÑÑ ÑÑÑÐµÑÑÐ²ÑÑÑÐµÐ³Ð¾ ÐºÐ»Ð¸ÐµÐ½ÑÐ°" onClick={() => setPicking(true)} />
            </div>
          )}

          {error && <p style={{ color: colors.red, marginTop: 12 }}>{error}</p>}
        </>
      )}

      <ClientCreateModal
        isOpen={modal}
        onRequestClose={() => setModal(false)}
        hideKato
        hideLanguage
        onCreated={(option) => {
          onChange(option);
          setPicking(false);
        }}
      />
    </>
  );
};

export default SellerBlock;
